import { AceDocumentsApi } from '../../src/_api/ilerna-StudentAccount/src'
import { asyncLazySingleton } from '../_common/common';

export const documentosAce = new asyncLazySingleton(async () => new AceDocumentsApi());
